import React, { Component } from 'react';
import { func, bool } from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

import Snackbar from '../common/Snackbar';
import StudentsReportFilters from './StudentsReportFilters';
import StudentsReportType from './StudentsReportType';
import Input from '../common/Input';
import { exportStudents } from '../../actions/reportActions';
import '../../styles/student-report-modal.scss';

class StudentsReportModal extends Component {
  constructor() {
    super();

    this.state = {
      filters: { cycle: '', gradeInstance: '', bid: '', agreement: '' },
      currentCycle: {},
      type: 'basic',
      title: 'Reporte Alumnos',
      titleError: '',
      submitSuccess: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  onSubmit() {
    const { exportStudents } = this.props;
    const { filters, type, title } = this.state;
    if (title) {
      exportStudents(filters, type, title);
      this.onClose();
      this.setState({ submitSuccess: true });
    } else {
      this.setState({ titleError: 'Debe ingresar un nombre al reporte' });
    }
  }

  onChangeTitle(e) {
    const title = e.target.value;
    this.setState({ title, titleError: '' });
  }

  onClose() {
    const { onClose } = this.props;
    this.setState({
      filters: { cycle: '', gradeInstance: '', bid: '', agreement: '' },
      currentCycle: {},
      type: 'basic',
      title: '',
      titleError: ''
    });
    onClose();
  }

  render() {
    const { submitSuccess, filters, currentCycle, type, title, titleError } = this.state;
    const { show } = this.props;

    return (
      <div>
        <Snackbar
          open={submitSuccess}
          onClose={() => this.setState({ submitSuccess: false })}
          message="Su reporte está siendo procesado"
          buttonTitle="IR A REPORTES"
          linkTo="/reportes"
          linkButton
        />
        <Modal
          show={show}
          onHide={this.onClose}
          dialogClassName="student-report-modal"
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          <div className="close-icon" onClick={this.onClose}>
            <i className="material-icons">close</i>
          </div>
          <h2>Reporte de alumnos</h2>
          <div className="title-input">
            <Input
              input={{
                value: title,
                onChange: this.onChangeTitle
              }}
              type="text"
              label="Nombre"
              meta={{ touched: true, error: titleError }}
            />
          </div>
          <div className="content">
            <div>
              <h4>Filtros</h4>
              <StudentsReportFilters
                filters={filters}
                currentCycle={currentCycle}
                onChangeFilters={filters => this.setState({ filters })}
                onChangeCurrentCycle={currentCycle => this.setState({ currentCycle })}
              />
            </div>
            <div>
              <h4>Detalle</h4>
              <StudentsReportType
                type={type}
                onChange={type => this.setState({ type })}
              />
            </div>
          </div>
          <button className="default-button" onClick={this.onSubmit}>
            Generar Reporte
          </button>
        </Modal>
      </div>
    );
  }
}

StudentsReportModal.propTypes = {
  onClose: func.isRequired,
  show: bool.isRequired,
  exportStudents: func.isRequired
};

const mapDispatch = dispatch => ({
  exportStudents: (filters, type, title) => dispatch(exportStudents(filters, type, title))
});

export default connect(null, mapDispatch)(StudentsReportModal);



// WEBPACK FOOTER //
// ./src/components/report/StudentsReportModal.js